export default __webpack_public_path__ + "static/media/triangle-pointer-koplo.e0c5baf6.svg";